import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { API_PATH } from 'src/environments/environment';
import { ContractListEntityType } from 'src/app/domain/registration/interfaces/contract-list.interfaces';

@Injectable({
    providedIn: 'root'
})
export class ContractsService extends AbstractCrudService {
    override title: string = 'Contratos';
    override pluralTitle = 'Contratos';

    constructor(protected override httpClient: HttpClient) {
        super(httpClient, 'contracts');
    }

    getContractsByCustomer(customerId: string): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_PATH}contracts/customer/${customerId}`);
    }

    getContractsByPartner(partnerId: string): Observable<any[]> {
        return this.httpClient.get<any[]>(`${API_PATH}contracts/partner/${partnerId}`);
    }

    updateAllContractsStatus(entityId: string, entityType: ContractListEntityType = 'customer'): Observable<void> {
        const endpoint = entityType === 'customer' 
            ? `${API_PATH}contracts/customer/${entityId}/update-all`
            : `${API_PATH}contracts/partner/${entityId}/update-all`;
        
        return this.httpClient.patch<void>(endpoint, {});
    }

    forceRefreshStatus(contractId: string, contractType?: ContractListEntityType): Observable<any> {
        let params = new HttpParams();
        if (contractType) {
            params = params.set('contract_type', contractType);
        }
        return this.httpClient.patch(`${API_PATH}contracts/${contractId}/force-refresh`, {}, { params });
    }

    downloadContract(contractId: string, contractType?: ContractListEntityType): Observable<Blob> {
        let params = new HttpParams();
        if (contractType) {
            params = params.set('contract_type', contractType);
        }
        return this.httpClient.get(`${API_PATH}contracts/${contractId}/download`, {
            responseType: 'blob',
            params
        });
    }

    removeContract(contractId: string, contractType?: ContractListEntityType): Observable<void> {
        let params = new HttpParams();
        if (contractType) {
            params = params.set('contract_type', contractType);
        }
        
        const frontendApiUrl = window.location.origin;
        const headers = new HttpHeaders({ 'X-Frontend-URL': frontendApiUrl });

        return this.httpClient.delete<void>(
            `${API_PATH}contracts/${contractId}`,
            { headers, params }
        );
    }

    resendContractEmails(contractId: string, contractType?: ContractListEntityType): Observable<any> {
        let params = new HttpParams();
        if (contractType) {
            params = params.set('contract_type', contractType);
        }
        return this.httpClient.post(`${API_PATH}contracts/${contractId}/resend-emails`, {}, { params });
    }

    getWhatsappLinks(contractId: string, contractType?: ContractListEntityType): Observable<{ signers: any[] }> {
        let params = new HttpParams();
        if (contractType) {
            params = params.set('contract_type', contractType);
        }
        return this.httpClient.get<{ signers: any[] }>(
            `${API_PATH}contracts/${contractId}/whatsapp-links`,
            { params }
        );
    }
}
